import { CALL_API } from '../../../../redux-store/middleware';
import { ApplicationProps } from '../../../../redux-store/types/api-types';
import {
  CREATE_LUMPSUM_PAYMENT,
  CREATE_LUMPSUM_PAYMENT_SUCCESS,
  GET_AVAILABLE_BANKS,
  GET_AVAILABLE_BANKS_SUCCESS,
  GET_PAYMENT_STATUS,
  GET_PAYMENT_STATUS_SUCCESS,
  UPDATE_PAYMENT_TYPE,
  UPDATE_PAYMENT_TYPE_SUCCESS,
} from '../types/payment';

export const getPaymentStatus =
  (orderId: string) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/get-payment-status/${orderId}`,
        method: 'GET',
        types: [GET_PAYMENT_STATUS_SUCCESS, GET_PAYMENT_STATUS],
      },
    });
  };

export const getAvailableBanks =
  (body: Record<string, any>) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/get-available-banks`,
        method: 'POST',
        types: [GET_AVAILABLE_BANKS_SUCCESS, GET_AVAILABLE_BANKS],
        body,
      },
    });
  };

export const updatePaymentType =
  (body: any) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/update-payment-type`,
        method: 'POST',
        types: [UPDATE_PAYMENT_TYPE_SUCCESS, UPDATE_PAYMENT_TYPE],
        body,
      },
    });
  };

export const createLumpsumPayment =
  (body: any) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/lumpsum/create-payment`,
        method: 'POST',
        types: [CREATE_LUMPSUM_PAYMENT_SUCCESS, CREATE_LUMPSUM_PAYMENT],
        body,
      },
    });
  };
